import { createConfig, createFlowContext } from '@betterment/shared-components/src/components/flow/Flow';
import { Outlet, useParams } from 'react-router-dom';
import * as yup from 'yup';

export const TRUST_ACCOUNT_FLOW_CONFIG = createConfig({
  trust_details: {
    schema: yup.object({
      trustName: yup.string().required(),
      trustDate: yup.string().required(),
    }),
    dependencies: yup.object({}),
  },
  existingTrustSelection: {
    schema: yup.object({
      selectedTrustId: yup.string().required(),
    }),
    dependencies: yup.object({}),
  },
});

export const { FlowProvider, useStep: useTrustAccountStep } = createFlowContext(TRUST_ACCOUNT_FLOW_CONFIG);

export const TrustAccountFlow = () => {
  const { flowId } = useParams<{ flowId: string }>();

  return (
    <FlowProvider flowId={flowId}>
      <Outlet />
    </FlowProvider>
  );
};
